module.exports = __webpack_public_path__ + "media/assets/images/flags/la-36288f2159fdb5ee46bdf273f12b71a5.svg";